import {
    adcRequest,
    detectRouteChange,
    getHostForConfig,
    isAdblockPopupInit,
    loadApp,
    noAd,
    prepareSettings,
    setUANCVersion,
} from './pre-config.utils';
import { getDetection } from '../../services/detection';
import UancEvent from '../../services/UancEvent';
import { FORCE_AD_CONSOLE } from '../../configs/constants';
import { isAdConsolePluginToEmbed } from '../../services/plugins/plugins';

const preConfig = async () => {
    const { Ad } = window.Inpl;

    detectRouteChange();

    Ad.detection = getDetection();
    Ad.event = new UancEvent();
    await prepareSettings();
    await setUANCVersion();

    // popup o wykryciu adblocka
    if (isAdblockPopupInit()) {
        import(/* webpackChunkName: "Adblock-popup" */ '../../services/adblock-popup/adblock-popup').then((module) => module.default());
    }

    if (Ad.settings?.noAdvertisement) {
        return noAd();
    }

    // pobieranie konfiguracji
    Ad.host = getHostForConfig();
    Ad.config = await adcRequest();
    await loadApp();

    Ad.event.add(FORCE_AD_CONSOLE, window, () => {
        if (isAdConsolePluginToEmbed()) return; // adConsole uruchamiane standardowo poprzez url param / localStorage
        import(/* webpackChunkName: "AdConsole" */ '../../services/plugins/AdConsole/AdConsole').then((module) =>
            module.processAdConsole(true)
        );
    });
};

export default preConfig;
